var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('img',{attrs:{"width":"100%","src":require("@/assets/image/about_banner.jpg")}}),_c('div',{staticClass:"con"},[_c('div',{staticClass:"cn"},[_vm._v(_vm._s(_vm.topNav.name))]),_c('div',{staticClass:"en"},[_vm._v("Introduction")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }